import {call, delay, fork, put, takeLatest} from "redux-saga/effects";
import {
    INITIATE_LOGIN_RESET,
    INITIATE_LOGOUT,
    LOGIN,
    LOGIN_TOO_MANY_ATTEMPTS,
    loginFailureAction,
    registerLoginResetResponseAction
} from "./authActions";
import {requestLogin, requestPasswordReset} from "../../api/authApi";
import {endSession, setSession} from "../../axios-config/authSession";
import {pushHistory} from "../router/routerActions";
import {loadCommonAction} from "../common/commonActions";

function* processLogin({payload: {loginData}}) {
    try {
        const {data} = yield call(requestLogin, {
            studio: loginData.studio,
            artist: loginData.artist,
            password: loginData.password
        })
        yield call(setSession, {accessToken: data?.accessToken, refreshToken: data?.refreshToken})
        yield put(loadCommonAction())
        yield delay(1000);
        yield put(pushHistory('/'))
    } catch (err) {
        console.error('Login failed:', err?.response?.status, err?.message)
        // 429: too many attempts for this studio, artist or address; the user waits instead of retyping.
        yield put(loginFailureAction(err?.response?.status === 429 ? LOGIN_TOO_MANY_ATTEMPTS : undefined))
    }
}

function* processLogout() {
    yield call(endSession)
}

function* processInitiateLoginReset({payload}) {
    try {
        const {studio, artist, locale} = payload.resetData
        yield call(requestPasswordReset, {studio, artist, locale})
        yield put(registerLoginResetResponseAction({success: true}))
    } catch (error) {
        console.error('Password reset failed:', error?.response?.status, error?.message)
        yield put(registerLoginResetResponseAction({error: error.message}))
    }
}

function* watchLogin() {
    yield takeLatest(LOGIN, processLogin)
}

function* watchInitiateLogout() {
    yield takeLatest(INITIATE_LOGOUT, processLogout)
}

function* watchInitiateLoginReset() {
    yield takeLatest(INITIATE_LOGIN_RESET, processInitiateLoginReset)
}

const authSaga = [fork(watchLogin), fork(watchInitiateLogout), fork(watchInitiateLoginReset)]

export default authSaga
